//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import { store,mutations } from '@/observable/store'
import { creatOrder } from '@/model/trader/orderService'
import { preIdentity } from '@/model/activation/activeAppint'
import { receive } from '@/model/activation/activeAppint'
import { couponUse,couponPolicy } from '../../model/appointment/appointmentService';
import { toApp } from '@/utils/appBridge'
import Txrweb from '@/utils/mixin/mixinTxrweb'
export default {
    name:'confirmed',
    mixins:[Txrweb],
    data(){
        return{
            templateFlag:null,
            list:[],
            listShow:[true,true,true],
            fromPath:''
        }
    },
    created(){
        this.templateFlag = this.$route.query.templateFlag;
        console.log(Object.keys(this.insuranceParmes))
        if(!Object.keys(this.insuranceParmes).length){
            this.$toast('投保信息丢失，请重新投保')
            setTimeout(()=>{
                this.$router.go(-1)
            },2000)
        }
        this.getData()
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    },
    beforeRouteLeave(to,from,next){
        this.$loading.hide() 
        mutations.setInsuranceParmes({}) //清除投保信息
        next();
    },
    components:{
    },
    computed: {
        insuranceParmes() { //投保信息
            return store.InsuranceParmes
        },
        reviewType() { //投保类型
            return this.$route.query.reviewType
        },
    },
    mounted(){
        this.STATISTICS_CONFIG.insur_keynotice_page()

        if(this.templateFlag == 'ht_irok_plus'){ //目前只有 齐牙保plus增加此页面的回溯节点 
            this.confirmedTX()
        }
        
    },
    methods:{
        getData(){
            const url = 'https://static.soyoung.com/sy-pre/'+this.templateFlag+'-1603098600806.json'
            axios.get(url).then((res) => {
                this.list = res.data
                console.log(this.list)
            });
        },
        show(index){
            // this.show[index] = !this.show[index]
            if(this.listShow[index]){
                this.STATISTICS_CONFIG.insur_keynotice_expand_click()
            }else{
                this.STATISTICS_CONFIG.insur_keynotice_retract_click()
            }
            this.$set(this.listShow,index,!this.listShow[index])

        },
        goback(){
            // 清除投保信息
            mutations.setInsuranceParmes({})
            this.STATISTICS_CONFIG.insur_keynotice_no_click()
            this.$router.go(-1)
        },
        btnClick(){
            this.STATISTICS_CONFIG.insur_keynotice_yes_click()
            console.log(this.insuranceParmes)
            console.log(this.reviewType)
            let fn = this.reviewType +'fn'
            this[fn](this.insuranceParmes)
            if(fn == 'couponUsefn'){
                this.$loading.show('https://static.soyoung.com/sy-pre/apptLoading-1581577800693.gif')
            }else{
                this.$loading.show()
            }
        },
        creatOrderfn(parameter){ //保险投保
            console.log('creatOrderfn',parameter)
            creatOrder(parameter).then((data) => {
                this.$loading.hide()

                // 更新可回溯信息
                this.updataTX( parameter.applicant,data.out_trade_no, parameter.insure[0]);

                // 实付价格为0 跳转领取成功 
                if(parameter.amount == 0){
                    this.$router.push({
                        path: "/happySuccess",
                        query:{
                            templateFlag:this.templateFlag
                        }
                    });
                    return false
                }

                // paySuccessSate:'activation' 区分支付成功页面的样式 后期支付成功页面会统一 
                let paySuccessSate = ''
                if(this.fromPath == '/teeth' || this.fromPath == '/stencilShop'){
                    paySuccessSate = 'activation'
                }
                if(this.fromPath == '/insuranceInfo'){
                    paySuccessSate = 'universal'
                }
                
                // 去支付
                // if (
                //   data.redirect_info &&
                //   data.redirect_info.need_redirect &&
                //   data.redirect_info.redirect_url
                // ) {
                  this.STATISTICS("click", "sybao_ins_proinfo_pay_cashier_click");
                  this.$router.replace({
                    path: data.redirect_info.redirect_url,
                    flag: "postdisable",
                    query:{
                        paySuccessSate
                    }
                  });
                // } else {
                //   this.STATISTICS("click", "sybao_ins_proinfo_pay_cashier_click");
                //   this.$router.replace({
                //     path: "/pay",
                //     query: {
                //       outTrade: data.out_trade_no,
                //       uuid: data.uuid,
                //       flag: "postdisable",
                //       paySuccessSate
                //     },
                //   });
                // }
              })
            .catch((err) => {
                this.$loading.hide()
                if(err.code == '1201'){
                    // 跳转重复领取
                    this.$router.push({
                            path: "/happySuccess",
                            query:{
                                templateFlag:this.templateFlag,
                                codeNumber:75
                            }
                        });
                }else{
                    this.$toast(err.message);
                }
            });
        },
        couponUsefn(parameter){ //卡券投保
            console.log('couponUsefn',parameter)
             couponUse(parameter).then(data=>{
                // 更新可回溯信息
              this.updataTX(parameter,data.out_trade_no)
                // 延迟5秒 获取预约单号
                setTimeout(()=>{
                    couponPolicy(data.uuid).then(res=>{
                        this.$loading.hide()

                            this.$router.replace({
                                path: "/reservationStatus",
                                query:{
                                    uuid:data.uuid,
                                    order_no:res.order_no,
                                    flag : 'postdisable',
                                    templateFlag:this.templateFlag,
                                }
                            });
                    }).catch((err) => {
                        this.$loading.hide()
                        if(err.code == '1001'){
                            this.$alert({
                                msg:'请前往“我的保单”重新发起预约',
                                title:'预约失败',
                                img:"https://static.soyoung.com/sy-pre/tips-1581577800693.png",
                                confirmText:'查看保单',
                                onConfirm:()=>{
                                    this.$router.replace({
                                        path:'/MyInsurance',
                                        flag: "postdisable",
                                    })
                                }
                            })
                        }
                        
                    }).finally(()=>{
                        this.$loading.hide()
                    });
                },5000)
                
            }).catch((err) => {
                this.$loading.hide()
                this.$toast(err.message);

            }).finally(()=>{
                // this.$loading.hide()
            });

        },
        receivefn(obj){ //氧护保PLUS 单独领取
            console.log('receivefn',obj)
            receive(obj,obj.tmpl).then(data=>{
              // 更新可回溯信息
                this.updataTX(obj, data.out_trade_no)
              this.$loading.hide()
                this.$router.replace({
                    path: "/renewal",
                    query:{
                        templateFlag: obj.tmpl,
                        flag: "postdisable",
                    }
                })
            }).catch(err=>{
                this.$loading.hide()
                this.$toast(err.message);
            })
        },
        preIdentityfn(obj){ // 氧护保PLUS 跟单赠险 和 氧气保PLUS  单独领取
            console.log('preIdentityfn',obj)
            preIdentity(obj).then(data=>{
                // 更新可回溯信息
                this.updataTX(obj, data.sub_id)
              this.$loading.hide()
                if(this.CHANNAL_ID == 'APP' && !obj.is_event){
                    toApp('policy',{
                        insurance_id:data.sub_id
                    })
                }else if(this.CHANNAL_ID == 'wxCode' && !this.isEvent){
                    console.log("postMessage--",wx.miniProgram.postMessage);
                    // wx.miniProgram.postMessage({
                    //     insurance_id:data.sub_id,
                    //     pay_bx_order: 1
                    // })
                    wx.miniProgram.postMessage({ data: {
                        insurance_id:data.sub_id,
                        pay_bx_order: 1
                    }})
                    wx.miniProgram.navigateBack()
                }else{
                    this.$router.replace({
                        path: "/receiveSuccess",
                        query:{
                            uuid: data.order_id,
                            flag : 'postdisable'
                        }
                    })
                }
            }).catch(err=>{
                this.$loading.hide()
                this.$toast(err.message);
            })
        }



    }
}
